import { create } from 'zustand';
import { getFAQs, getContactInfo, FAQ, ContactInfo } from '@/services/Common/SupportService';

interface SupportState {
  faqs: FAQ[] | null;
  contactInfo: ContactInfo | null;
  loading: boolean;
  error: string | null;

  fetchFAQs: () => Promise<void>;
  fetchContactInfo: () => Promise<void>;
}

const useSupportStore = create<SupportState>((set, get) => ({
  faqs: null,
  contactInfo: null,
  loading: false,
  error: null,

  fetchFAQs: async () => {
    try {
      set({ loading: true, error: null });
      const response = await getFAQs();
      set({ faqs: response.data || [], loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  fetchContactInfo: async () => {
    try {
      set({ loading: true, error: null });
      const response = await getContactInfo();
      set({ contactInfo: response.data || null, loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },
}));

export default useSupportStore;
